<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import type { Organization, WebSite, WithContext } from "schema-dts";
	import StructuredData from "../components/common/StructuredData.svelte";
	import Benefits from "../components/home/Benefits.svelte";
	import Bio from "../components/home/Bio.svelte";
	import Booking from "../components/home/Booking.svelte";
	import Faq from "../components/home/Faq.svelte";
	import Hero from "../components/home/Hero.svelte";
	import LatestArticles from "../components/home/LatestArticles.svelte";
	import Procedures from "../components/home/Procedures.svelte";
	import Process from "../components/home/Process.svelte";
	import Reviews from "../components/home/Reviews.svelte";
	import Steps from "../components/home/Steps.svelte";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import type { HomepageProps } from "./HomepageProps.js";

	const { latestNews, featuredProcedures }: HomepageProps = $props();
	const { WEB_URL } = getGlobalSettings();

	const organizationSchema: Organization = {
		"@type": "Organization",
		name: "Head Spa Napohodu",
		url: WEB_URL,
		logo: `${WEB_URL}/favicon.ico`,
		description:
			"Head Spa je relaxační wellness procedura, která kombinuje péči o vlasovou pokožku a vlasy s hlubokou relaxací. U nás je navíc součástí i jemná péče o pleť.",
		address: {
			"@type": "PostalAddress",
			streetAddress: "Hrnčířská 42/5",
			addressLocality: "Karviná",
			postalCode: "733 01",
			addressCountry: "CZ",
		},
		contactPoint: {
			"@type": "ContactPoint",
			telephone: "+420 727 955 703",
			email: "info@headspa-napohodu.cz",
			contactType: "customer service",
		},
		sameAs: ["https://www.instagram.com/headspa.napohodu/", "https://www.facebook.com/profile.php?id=61564095014831"],
	};

	const websiteSchema: WebSite = {
		"@type": "WebSite",
		name: "Head Spa Napohodu",
		url: WEB_URL,
		description: "Zažij Head Spa v Karviné napohodu. Nech zastavit čas, vypni hlavu. Dopřej si klid a relaxaci.",
		publisher: {
			"@type": "Organization",
			name: "Head Spa Napohodu",
		},
	};
</script>

<StructuredData data={organizationSchema} />
<StructuredData data={websiteSchema} />

<Layout>
	<Hero />
	<Benefits />
	<Procedures {featuredProcedures} />
	<Steps />
	<Process />
	<Booking style="booking" />
	<Reviews />
	<Bio />
	<Faq page="homepage" />
	<LatestArticles articles={latestNews} />
</Layout>
